"use client";

import { useStartViewTransitionValue } from "use-start-view-transition";

import { NotificationItem } from "@/components/app/notifications/notification-item/notification-item";
import { NotificationSkeleton } from "@/components/app/notifications/notification-skeleton";
import { useNotificationsContext } from "@/components/app/notifications/notifications-context";
import { EmptyState } from "@/components/shared/empty-state";

export const EarningsNotificationsTable = () => {
  const {
    notifications,
    lazyLoadingMarkup,
    relativeUsername,
    initialLoading: _initialLoading,
  } = useNotificationsContext();
  const initialLoading = useStartViewTransitionValue(_initialLoading, {
    skipTransition: _initialLoading,
  });

  return (
    <>
      {notifications.map((n) => (
        <NotificationItem
          key={n.Notification.Id}
          notification={n}
          {...{
            relativeUsername,
          }}
        />
      ))}

      {!initialLoading && lazyLoadingMarkup}
      {initialLoading && (
        <div className="flex flex-col gap-4 p-4">
          {Array.from({ length: 5 }).map((_, index) => (
            <NotificationSkeleton key={index} />
          ))}
        </div>
      )}

      {!notifications.length && !initialLoading && (
        <div className="py-24">
          <EmptyState
            image="/assets/empty-15.png"
            title="We couldn't find any records for you."
            description="You might want to adjust your filters."
          />
        </div>
      )}
    </>
  );
};
